import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function InstagramCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setToken = useAuthStore((state) => state.setToken);
  const setUser = useAuthStore((state) => state.setUser);
  const setLoading = useAuthStore((state) => state.setLoading);
  const setError = useAuthStore((state) => state.setError);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        setError('Instagram authentication was cancelled or failed');
        navigate('/login');
        return;
      }

      if (!code) {
        setError('No authorization code received from Instagram');
        navigate('/login');
        return;
      }

      try {
        setLoading(true);

        // Exchange code for access token (this should ideally be done on backend)
        // For now, we'll send the code to our backend to handle the exchange
        const response = await fetch(`${API_BASE_URL}/api/auth/instagram/callback`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirectUri: `${window.location.origin}/auth/instagram/callback`,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || data.message || 'Instagram authentication failed');
        }

        setToken(data.token);
        setUser(data.user);

        // If new user (isNew flag) or no phone verified, redirect to phone verification
        if (data.isNew || !data.user?.phone_verified) {
          navigate('/verify-phone', { state: { fromOAuth: true } });
        } else {
          // Redirect to the stored page or home
          const redirectPath = sessionStorage.getItem('instagram_redirect') || '/';
          sessionStorage.removeItem('instagram_redirect');
          navigate(redirectPath);
        }
      } catch (err) {
        console.error('Instagram callback error:', err);
        setError(err.message);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setToken, setUser, setLoading, setError]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div>Processing Instagram authentication...</div>
    </div>
  );
}

